import './Photography.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React from 'react';
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';



export default class Photography extends React.Component {
  handleKeyDown = (e) => {
    if (!this.state.show) return;
    const code = e.keyCode || e.which;
    if (code === 39) { // ArrowRight
      this.state.photos.length > this.state.selectedIndex+1 ? this.setState({selectedIndex:this.state.selectedIndex+1}) : this.setState({selectedIndex:0});
    }
    if (code === 37) { // ArrowLeft
      this.state.selectedIndex > 0 ? this.setState({selectedIndex:this.state.selectedIndex-1}) : this.setState({selectedIndex:this.state.photos.length-1});
    }
  }
  
  evento(){
    this.state.photos.length > this.state.selectedIndex+1 ? this.setState({selectedIndex:this.state.selectedIndex+1}):this.setState({selectedIndex:0})
  }
  eventoback(){
  this.state.selectedIndex > 0 ? this.setState({selectedIndex:this.state.selectedIndex-1}):this.setState({selectedIndex:this.state.photos.length-1})
  }

  state = {
    photos: [],
    loading: true,
    modalShow: false,
    show: false,
    selectedPhoto: {"name":"cosa"},
    selectedIndex: 0
  }


  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
    this.isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0);
    const apiToken= process.env.REACT_APP_IARENAS_PHOTO;
    const getPhotosAPI='https://5zk1teqy2j.execute-api.us-east-1.amazonaws.com/default/getPhotos'

    axios.post(
      getPhotosAPI,
      {'format':'' },
      { 
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': apiToken
        }
      }).then(res => {
        const photos = res.data || [];
        this.setState({ photos, loading: false });  
      }).catch(err => {
        console.error('Error fetching photos', err);
        this.setState({ loading: false });
      })
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  // Touch handlers for mobile swipe
  handleTouchStart = (e) => {
    if (!this.isTouchDevice) return;
    this._touchStartX = e.touches && e.touches[0] ? e.touches[0].clientX : null;
    this._touchEndX = null;
  }

  handleTouchMove = (e) => {
    if (!this.isTouchDevice) return;
    this._touchEndX = e.touches && e.touches[0] ? e.touches[0].clientX : null;
  }

  handleTouchEnd = () => {
    if (!this.isTouchDevice) return;
    if (this._touchStartX == null) return;
    const endX = (this._touchEndX != null) ? this._touchEndX : this._touchStartX;
    const dx = this._touchStartX - endX;
    const threshold = 50; // px
    if (Math.abs(dx) > threshold) {
      if (dx > 0) {
        // swipe left -> next
        this.evento();
      } else {
        // swipe right -> prev
        this.eventoback();
      }
    }
    this._touchStartX = this._touchEndX = null;
  }
  
  render() {
    return (
      <Container fluid className="Photography">
        <div  key="blankDiv" className='blankMenuRow'></div> 
        {this.state.loading && (
          <div className="LoadingOverlay">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}

        <Row key="RowDiv">
        {
          this.state.photos.map( (photo,i) =>
            <Col key={photo.id} className= "photoFrame"
              cols={(photo.format  === 'vertical'? 1: 2 )* 2}
              xs={(photo.format  === 'vertical'? 1: 2 )* 3}
              sm={(photo.format  === 'vertical'? 1: 2 )* 3}
              lg={(photo.format === 'vertical'? 1: 2 ) * 3}
              md={(photo.format === 'vertical'? 1: 2 ) * 3} 
              xl={(photo.format === 'vertical'? 1: 2 )* 2}
            > 
              <img src={photo.main_url} className="Photo" alt={photo.name} onClick={()=> {this.setState({show:true});this.setState({selectedIndex:i})}}/>
            </Col>
          )
        }
        </Row>
        <Modal key="modalKey" show={this.state.show} onHide={()=> {this.setState({show:false})}} size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <Modal.Body className='PhotoModal'>    
            <div className='sPhotoFrame'>
              <center>
              {this.state.photos[this.state.selectedIndex] && (
                <center>
                <img src={this.state.photos[this.state.selectedIndex].main_url} 
                  className={this.state.photos[this.state.selectedIndex].format==='vertical' ? "sPhotoVertical":"sPhotoHorizontal" } 
                  alt={this.state.photos[this.state.selectedIndex].name} />
                  </center>
              )}
              </center>
              <div className="BackDivision" onClick={()=> { this.eventoback()}}></div> 
              <div className="NextDivision" onClick={()=> { this.evento()}}></div> 
            </div>
          </Modal.Body>
        </Modal>
      </Container>
      
    );
  }
}

